import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useProfileService } from '../../../../apis/profile/useProfileService';
import { TEventsPrimary } from '../../../../apis/events/events.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getProfileCalendarItemKey = 'get-profile-calendar-item';

export const useProfileCalendarItemHook = (
  eventId: string,
  options?: Omit<
    UseQueryOptions<TEventsPrimary, TQueryError>,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<TEventsPrimary, TQueryError> => {
  const { getProfileCalendarItem } = useProfileService();

  return useQuery<TEventsPrimary, TQueryError>({
    queryKey: [getProfileCalendarItemKey, eventId],
    queryFn: () => getProfileCalendarItem(eventId),
    enabled: options?.enabled !== undefined ? options.enabled : !!eventId,
    ...options,
  });
};
